import {
    FETCH_LUMINFOS,
    GET_TYPE_LUMINFOS,
    UPDATE_TYPE_LUMINFOS,
    FETCH_PROPERTIES_LUMINFOS,
    UPDATE_PROPERTIES_LUMINFOS
} from '../actions/types';

const INITIAL_STATE = {
    type: null,
    types: null,
    validationSummary: null,
    lumInfosProperties: null
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {

        case FETCH_LUMINFOS:
            return Object.assign({}, state, {
                types: action.payload,
            });
        case GET_TYPE_LUMINFOS:
            return Object.assign({}, state, {
                type: action.payload,
            });
        case UPDATE_TYPE_LUMINFOS:
            return Object.assign({}, state, {
                validationSummary: action.payload,
            });
        case FETCH_PROPERTIES_LUMINFOS:
            return Object.assign({}, state, {
                lumInfosProperties: action.payload,
            });
        case UPDATE_PROPERTIES_LUMINFOS:
            return Object.assign({}, state, {
                validationSummary: action.payload,
            });
        default:
            return state;
    }
};
